import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const container = css`
  padding-inline: ${spacing(2)};
  transform: translateZ(0); // для Safari
`
export const subTitle = css`
  opacity: 0.5;
`
